/**
 * useDrawer.ts
 * Hook pour gérer l'état du drawer (sidebar)
 */
import { useState, useCallback } from 'react';

export interface DrawerState {
  isOpen: boolean;
  drawerType: 'project' | 'templates' | 'layouts' | 'text' | 'elements' | 'uploads' | null;
}

export interface DrawerActions {
  openDrawer: (type: DrawerState['drawerType']) => void;
  closeDrawer: () => void;
  toggleDrawer: (type: DrawerState['drawerType']) => void;
}

/**
 * Hook pour gérer le drawer
 */
export function useDrawer(): DrawerState & DrawerActions {
  const [isOpen, setIsOpen] = useState(false);
  const [drawerType, setDrawerType] = useState<DrawerState['drawerType']>(null);

  const openDrawer = useCallback((type: DrawerState['drawerType']) => {
    // SUPPRIMÉ: Logs dans hook critique (performance)
    setDrawerType(type);
    setIsOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsOpen(false);
    setDrawerType(null);
  }, []);

  const toggleDrawer = useCallback(
    (type: DrawerState['drawerType']) => {
      if (isOpen && drawerType === type) {
        closeDrawer();
      } else {
        openDrawer(type);
      }
    },
    [isOpen, drawerType, openDrawer, closeDrawer]
  );

  return {
    isOpen,
    drawerType,
    openDrawer,
    closeDrawer,
    toggleDrawer,
  };
}
